import Service from './Service';

/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
class SecretariaService extends Service {

    recuperarParametros() {
        return this.getSecretariaApi().recuperarParametros();
    }

    recuperarFeaturesFlags() {
        return this.getSecretariaApi().recuperarFeaturesFlags();
    }

    recuperarMagistrados() {
        return this.getSecretariaApi().recuperarMagistrados();
    }

    recuperarDescricoesCargos() {
        return this.getSecretariaApi().recuperarDescricoesCargos();
    }

    recuperarClasses() {
        return this.getSecretariaApi().recuperarClasses();
    }

    recuperarProcuradores() {
        return this.getSecretariaApi().recuperarProcuradores();
    }

    recuperarSignatariosCertidao() {
        return this.getSecretariaApi().recuperarSignatariosCertidao();
    }

    gravarParametro(parametro) {
        return this.getSecretariaApi().gravarParametro(parametro);
    }

    salvarParametro(parametro) {
        return this.getSecretariaApi().salvarParametro(parametro);
    }

    excluirParametro(idParametro) {
        return this.getSecretariaApi().excluirParametro(idParametro);
    }
}

export default SecretariaService;
